import type { StatusVariantMap } from '@zafroi/ui-kit';

/**
 * StatusBadge dictionaries for the Kosh lifecycle enums. The kit ships no
 * default mapping — each app supplies its own (tone + label).
 */
export const invoiceStatusVariants: StatusVariantMap = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  ISSUED: { label: 'Issued', tone: 'info' },
  PARTIALLY_PAID: { label: 'Partially paid', tone: 'warning' },
  PAID: { label: 'Paid', tone: 'success' },
  OVERDUE: { label: 'Overdue', tone: 'destructive' },
  CANCELLED: { label: 'Cancelled', tone: 'neutral' },
  VOID: { label: 'Void', tone: 'neutral' },
};

export const outstandingStatusVariants: StatusVariantMap = {
  OPEN: { label: 'Open', tone: 'warning' },
  PARTIALLY_SETTLED: { label: 'Partially settled', tone: 'info' },
  SETTLED: { label: 'Settled', tone: 'success' },
  WRITTEN_OFF: { label: 'Written off', tone: 'neutral' },
};

export const accountStatusVariants: StatusVariantMap = {
  ACTIVE: { label: 'Active', tone: 'success' },
  ON_HOLD: { label: 'On hold', tone: 'warning' },
  INACTIVE: { label: 'Inactive', tone: 'neutral' },
  ARCHIVED: { label: 'Archived', tone: 'neutral' },
};

export const settlementStatusVariants: StatusVariantMap = {
  RECORDED: { label: 'Recorded', tone: 'info' },
  CONFIRMED: { label: 'Confirmed', tone: 'success' },
  REVERSED: { label: 'Reversed', tone: 'destructive' },
};

export const activityStatusVariants: StatusVariantMap = {
  PLANNED: { label: 'Planned', tone: 'info' },
  DONE: { label: 'Done', tone: 'success' },
  FOLLOW_UP: { label: 'Follow-up', tone: 'warning' },
};

export const reminderStatusVariants: StatusVariantMap = {
  SCHEDULED: { label: 'Scheduled', tone: 'info' },
  SENT: { label: 'Sent', tone: 'success' },
  FAILED: { label: 'Failed', tone: 'destructive' },
  CANCELLED: { label: 'Cancelled', tone: 'neutral' },
};
